// src/v3/interactions/chevron-right.tsx
import SvgIcon from "@mui/material/SvgIcon";
import { jsx } from "react/jsx-runtime";
var ChevronRightIcon = (props) => /* @__PURE__ */ jsx(SvgIcon, { "data-testid": "ChevronRightIcon", viewBox: "0 0 24 24", ...props, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentColor",
    d: "M15.8045 12.4645L9.13858 19.1304C9.07664 19.1924 9.00312 19.2415 8.9222 19.275C8.84128 19.3085 8.75455 19.3258 8.66696 19.3258C8.57938 19.3258 8.49265 19.3085 8.41173 19.275C8.33081 19.2415 8.25728 19.1924 8.19535 19.1304C8.13342 19.0685 8.08429 18.995 8.05077 18.914C8.01725 18.8331 8 18.7464 8 18.6588C8 18.5712 8.01725 18.4845 8.05077 18.4036C8.08429 18.3227 8.13342 18.2491 8.19535 18.1872L14.3905 11.9929L8.19535 5.79858C8.07027 5.6735 8 5.50386 8 5.32697C8 5.15008 8.07027 4.98043 8.19535 4.85535C8.32043 4.73027 8.49007 4.66 8.66696 4.66C8.84385 4.66 9.0135 4.73027 9.13858 4.85535L15.8045 11.5213C15.8665 11.5832 15.9156 11.6567 15.9492 11.7376C15.9827 11.8185 16 11.9053 16 11.9929C16 12.0805 15.9827 12.1672 15.9492 12.2482C15.9156 12.3291 15.8665 12.4026 15.8045 12.4645Z"
  }
) });

export {
  ChevronRightIcon
};
